import styles from "../edithome/EditHome.module.scss";
import Contact from "../../home/templates/components/Contact";
import FormContainer from "../../formbuilder/formcomponents/FormContainer";

function Edit() {
  return (
    <div className={styles.maincontainer}>
      <div className={styles.formcontainer}>
        <div>
          <FormContainer />
        </div>
      </div>
      <div className={styles.componentcontainer}>
        {/* <Header /> */}
        <Contact />
      </div>
    </div>
  );
}

export default Edit;
